import Backdraft from "backdraft-app/src/backdraft";

Backdraft.app("Shared/ExpressionBuilder", function(app) {
  app.TerminalMetaData = {
    gender: {
      possibleValues: ["male", "female"]
    },
    address_type: {
      possibleValues: function(config) {
        if (config.enhancedCallerProfiles === 'Infutor') {
          return [
            'Firm or Company Address',
            'General Delivery Address',
            'High-rise or Business Complex',
            'PO Box Address',
            'Rural Route Address',
            'Street or Residential Address'
          ];
        } else if (config.enhancedCallerProfiles === 'WhitePages') {
          return [
            'CommercialMailDrop',
            'MultiUnit',
            'SingleUnit',
            'POBox',
            'POBoxThrowback',
            'UnknownAddressType'
          ];
        } else {
          throw new Error("Unsupported enhancedCallerProfiles: " + config.enhancedCallerProfiles);
        }
      }
    },
    marital_status: {
      possibleValues: ['married', 'single']
    },
    home_owner_status: {
      possibleValues: ['rent', 'own']
    },
    education: {
      possibleValues: [
        'completed high school',
        'attended college',
        'completed college',
        'completed graduate school',
        'attended vocational/technical'
      ]
    },
    occupation: {
      possibleValues: [
        'blue collar worker',
        'business owner',
        'civil service',
        'technology',
        'executive/upper management',
        'health services',
        'homemaker',
        'middle management',
        'military personnel',
        'nurse',
        'part time',
        'professional',
        'retired',
        'secretary',
        'student',
        'teacher',
        'white collar worker'
      ]
    }
  };
});
